"use client";

import { useEffect } from 'react';
import { trackContactClick } from './conversions.mjs';

export default function ContactClickTracking() {
  useEffect(() => {
    const handleClick = (event) => {
      if (event.defaultPrevented || (event.type === 'auxclick' && event.button !== 1)) return;
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (link) trackContactClick(link.getAttribute('href'));
    };
    document.addEventListener('click', handleClick);
    document.addEventListener('auxclick', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('auxclick', handleClick);
    };
  }, []);
  return null;
}
